/**
 * goc-pdp-anchor-navigation section
 * Sticky overlay: same motion as `.section-header` — top 0.4s ease-in-out between shown row and -120px (see header.liquid).
 * Most links: data-pdp-anchor-navigation-target-id → document.getElementById.
 * Main product (PDP): data-pdp-anchor-navigation-target-kind="main-product" → primary product-info in main.
 * Desktop: single row without horizontal scroll — font-size & column gap shrink to fit (labels stay complete).
 */
(function () {
  if (window.__gocPdpAnchorNavigationBootstrapped) {
    return;
  }
  window.__gocPdpAnchorNavigationBootstrapped = true;

  var MAIN_PRODUCT_HASH_KEY = 'pdp-anchor-main-product';

  function resolveMainProductPdpElement() {
    return (
      document.querySelector('main product-info[id^="MainProduct"]') ||
      document.querySelector('product-info[id^="MainProduct"]') ||
      document.querySelector('main product-info') ||
      document.querySelector('product-info')
    );
  }

  function getNavigationLinkScrollKey(navigationLinkElement) {
    if (navigationLinkElement.getAttribute('data-pdp-anchor-navigation-target-kind') === 'main-product') {
      return MAIN_PRODUCT_HASH_KEY;
    }
    return (navigationLinkElement.getAttribute('data-pdp-anchor-navigation-target-id') || '').replace(/^\s+|\s+$/g, '');
  }

  function resolveNavigationLinkScrollTarget(navigationLinkElement) {
    if (navigationLinkElement.getAttribute('data-pdp-anchor-navigation-target-kind') === 'main-product') {
      return resolveMainProductPdpElement();
    }
    var trimmedDomId = (navigationLinkElement.getAttribute('data-pdp-anchor-navigation-target-id') || '').replace(
      /^\s+|\s+$/g,
      ''
    );
    if (!trimmedDomId) return null;
    return document.getElementById(trimmedDomId);
  }

  /**
   * Last known `.section-header` sticky `top` while header is visible (e.g. 20px). Used when header is hidden so we
   * do not read `getComputedStyle(top)` during the slide-off animation (negative px).
   */
  var cachedHeaderStickyInsetTopPx = 20;

  function refreshCachedHeaderInsetFromVisibleHeader() {
    var headerEl = document.querySelector('.section-header');
    if (!headerEl || headerEl.classList.contains('shopify-section-header-hidden')) return;
    var topValue = window.getComputedStyle(headerEl).top;
    if (topValue && topValue !== 'auto') {
      var parsed = parseFloat(topValue);
      if (!isNaN(parsed)) cachedHeaderStickyInsetTopPx = parsed;
    }
  }

  /** Viewport offset for scroll threshold: under visible header, or top inset when header is hidden (scroll down). */
  function getScrollThresholdDockPx() {
    var headerEl = document.querySelector('.section-header');
    if (!headerEl) return cachedHeaderStickyInsetTopPx;
    if (headerEl.classList.contains('shopify-section-header-hidden')) {
      return cachedHeaderStickyInsetTopPx;
    }
    return headerEl.getBoundingClientRect().bottom;
  }

  function isMobilePdpAnchorNavigationViewport() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 989px)').matches;
  }

  /** 与 StickyHeader 打同一 class 节奏；避免快速滚动时节流 rAF 晚一拍导致 top 过渡卡死 */
  function registerSectionHeaderClassObserverOnce() {
    if (window.__gocPdpAnchorHeaderClassObserverRegistered) {
      return;
    }
    window.__gocPdpAnchorHeaderClassObserverRegistered = true;

    var headerSection = document.querySelector('.section-header');
    if (!headerSection || typeof MutationObserver === 'undefined') {
      return;
    }

    var flushHeaderLinkedAnchorState = function () {
      refreshCachedHeaderInsetFromVisibleHeader();
      document
        .querySelectorAll('[data-pdp-anchor-navigation-root][data-pdp-anchor-navigation-initialized="true"]')
        .forEach(function (root) {
          if (typeof root.__pdpAnchorNavigationSyncFromHeader === 'function') {
            root.__pdpAnchorNavigationSyncFromHeader();
          }
        });
    };

    new MutationObserver(flushHeaderLinkedAnchorState).observe(headerSection, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function navigationTrackHasHorizontalOverflow(trackElement) {
    if (!trackElement) return false;
    return trackElement.scrollWidth > trackElement.clientWidth + 2;
  }

  /** Smooth-scroll horizontal track so link is centered; does not trap user scroll/touch. */
  function centerNavigationLinkInHorizontalTrack(navigationLinkElement, navigationTrackElement) {
    if (!navigationLinkElement || !navigationTrackElement) return;
    if (!navigationTrackHasHorizontalOverflow(navigationTrackElement)) return;

    var linkRect = navigationLinkElement.getBoundingClientRect();
    var trackRect = navigationTrackElement.getBoundingClientRect();
    var linkCenterX = linkRect.left + linkRect.width / 2;
    var trackCenterX = trackRect.left + trackRect.width / 2;
    var delta = linkCenterX - trackCenterX;
    var nextLeft = navigationTrackElement.scrollLeft + delta;
    var maxScrollLeft = Math.max(0, navigationTrackElement.scrollWidth - navigationTrackElement.clientWidth);
    navigationTrackElement.scrollTo({
      left: Math.max(0, Math.min(nextLeft, maxScrollLeft)),
      behavior: 'smooth',
    });
  }

  function initPdpAnchorNavigation(navigationRootElement) {
    if (!navigationRootElement || navigationRootElement.getAttribute('data-pdp-anchor-navigation-initialized') === 'true') {
      return;
    }
    navigationRootElement.setAttribute('data-pdp-anchor-navigation-initialized', 'true');

    var stickyLayerElement = navigationRootElement.querySelector('[data-pdp-anchor-navigation-sticky-layer]');
    var navigationTrackElement = navigationRootElement.querySelector('[data-pdp-anchor-navigation-track]');
    var underlineIndicatorElement = navigationRootElement.querySelector('[data-pdp-anchor-navigation-underline]');
    var navigationLinkNodeList = navigationTrackElement
      ? navigationTrackElement.querySelectorAll('a.pdp-anchor-navigation__link')
      : [];
    var navigationLinkElements = Array.prototype.slice.call(navigationLinkNodeList);

    if (!stickyLayerElement || !navigationTrackElement || !underlineIndicatorElement || navigationLinkElements.length === 0) {
      return;
    }

    registerSectionHeaderClassObserverOnce();

    /** Scroll-spy only: last applied key; used to center the tab strip once when the active item changes (mobile). */
    var scrollSpyPreviousActiveScrollKey = null;

    var navigationNaturalTopDocument = 0;

    function refreshNavigationNaturalTopDocument() {
      if (navigationRootElement.getAttribute('data-pdp-anchor-navigation-sticky') === 'true') {
        return;
      }
      navigationNaturalTopDocument =
        stickyLayerElement.getBoundingClientRect().top + window.scrollY;
    }

    function syncHeaderMetricsToAnchorRoot() {
      var headerBar = document.querySelector('.section-header .header');
      if (!headerBar) {
        return;
      }
      var rect = headerBar.getBoundingClientRect();
      var w = Math.round(rect.width);
      var h = Math.round(rect.height);
      navigationRootElement.style.setProperty('--pdp-anchor-header-bar-width', w + 'px');
      navigationRootElement.style.setProperty('--pdp-anchor-header-bar-height', h + 'px');
      navigationRootElement.setAttribute('data-pdp-anchor-has-live-metrics', 'true');
      var hideOffsetPx = Math.max(120, Math.round(h + 32));
      navigationRootElement.style.setProperty('--pdp-anchor-hide-top', '-' + hideOffsetPx + 'px');
    }

    function syncOverlayFromSectionHeader() {
      syncHeaderMetricsToAnchorRoot();
      stickyLayerElement.style.setProperty('--pdp-anchor-shown-top', cachedHeaderStickyInsetTopPx + 'px');
      if (navigationRootElement.getAttribute('data-pdp-anchor-navigation-sticky') !== 'true') {
        return;
      }
      var headerEl = document.querySelector('.section-header');
      var headerHidden = !!(headerEl && headerEl.classList.contains('shopify-section-header-hidden'));
      stickyLayerElement.setAttribute('data-pdp-anchor-overlay-active', 'true');
      stickyLayerElement.setAttribute('data-pdp-anchor-overlay-concealed', headerHidden ? 'false' : 'true');
      if (headerHidden) {
        stickyLayerElement.removeAttribute('aria-hidden');
      } else {
        stickyLayerElement.setAttribute('aria-hidden', 'true');
      }
    }

    navigationRootElement.__pdpAnchorNavigationSyncFromHeader = syncOverlayFromSectionHeader;

    var stickyLayerResizeObserver = null;

    stickyLayerElement.addEventListener('transitionend', function (ev) {
      if (ev.target !== stickyLayerElement || ev.propertyName !== 'top') {
        return;
      }
      if (navigationRootElement.getAttribute('data-pdp-anchor-navigation-sticky') !== 'true') {
        return;
      }
      navigationRootElement.style.minHeight = stickyLayerElement.offsetHeight + 'px';
    });
    if (typeof ResizeObserver !== 'undefined') {
      stickyLayerResizeObserver = new ResizeObserver(function () {
        if (navigationRootElement.getAttribute('data-pdp-anchor-navigation-sticky') === 'true') {
          navigationRootElement.style.minHeight = stickyLayerElement.offsetHeight + 'px';
        }
      });
      stickyLayerResizeObserver.observe(stickyLayerElement);
    }

    function applyStickyNavigationReleaseStyles() {
      navigationRootElement.style.minHeight = '';
      stickyLayerElement.style.position = '';
      stickyLayerElement.style.top = '';
      stickyLayerElement.style.left = '';
      stickyLayerElement.style.right = '';
      stickyLayerElement.style.zIndex = '';
      stickyLayerElement.style.width = '';
      stickyLayerElement.style.removeProperty('--pdp-anchor-shown-top');
      stickyLayerElement.removeAttribute('data-pdp-anchor-overlay-active');
      stickyLayerElement.removeAttribute('data-pdp-anchor-overlay-concealed');
      stickyLayerElement.removeAttribute('aria-hidden');
      navigationRootElement.removeAttribute('data-pdp-anchor-navigation-sticky');
      refreshNavigationNaturalTopDocument();
    }

    function applyStickyNavigationDockStyles() {
      syncHeaderMetricsToAnchorRoot();
      navigationRootElement.style.minHeight = stickyLayerElement.offsetHeight + 'px';
      stickyLayerElement.style.position = 'fixed';
      stickyLayerElement.style.top = '';
      stickyLayerElement.style.left = '0';
      stickyLayerElement.style.right = '0';
      stickyLayerElement.style.zIndex = '999';
      stickyLayerElement.style.width = '100%';
      navigationRootElement.setAttribute('data-pdp-anchor-navigation-sticky', 'true');
    }

    function getScrollClickOffsetBelowFixedChromePx() {
      var headerEl = document.querySelector('.section-header');
      if (!headerEl) {
        return getScrollThresholdDockPx();
      }
      if (headerEl.classList.contains('shopify-section-header-hidden')) {
        return cachedHeaderStickyInsetTopPx + stickyLayerElement.offsetHeight;
      }
      return headerEl.getBoundingClientRect().bottom;
    }

    function updateStickyNavigationDock() {
      refreshCachedHeaderInsetFromVisibleHeader();
      syncHeaderMetricsToAnchorRoot();
      var headerEl = document.querySelector('.section-header');
      var insetPx = cachedHeaderStickyInsetTopPx;
      var headerHidden = !!(headerEl && headerEl.classList.contains('shopify-section-header-hidden'));
      var headerBottomPx =
        headerEl && !headerHidden ? headerEl.getBoundingClientRect().bottom : insetPx;

      if (headerEl && !headerHidden) {
        var prevMaxBottom = navigationRootElement.__pdpAnchorMaxObservedHeaderBottomPx || 0;
        navigationRootElement.__pdpAnchorMaxObservedHeaderBottomPx = Math.max(prevMaxBottom, headerBottomPx);
      }

      var maxObservedDockPx = Math.max(
        insetPx,
        navigationRootElement.__pdpAnchorMaxObservedHeaderBottomPx || headerBottomPx
      );
      var releaseLineY = navigationNaturalTopDocument - maxObservedDockPx - 0.5;
      var activateLineY = navigationNaturalTopDocument - (headerHidden ? insetPx : headerBottomPx) - 0.5;

      var isCurrentlySticky = navigationRootElement.getAttribute('data-pdp-anchor-navigation-sticky') === 'true';
      var shouldStickBelowHeader = isCurrentlySticky
        ? window.scrollY >= releaseLineY
        : window.scrollY >= activateLineY;

      stickyLayerElement.style.setProperty('--pdp-anchor-shown-top', insetPx + 'px');

      if (shouldStickBelowHeader) {
        if (!isCurrentlySticky) {
          applyStickyNavigationDockStyles();
        }
        stickyLayerElement.setAttribute('data-pdp-anchor-overlay-active', 'true');
        stickyLayerElement.setAttribute('data-pdp-anchor-overlay-concealed', headerHidden ? 'false' : 'true');
        if (headerHidden) {
          stickyLayerElement.removeAttribute('aria-hidden');
        } else {
          stickyLayerElement.setAttribute('aria-hidden', 'true');
        }
      } else {
        if (isCurrentlySticky) {
          navigationRootElement.__pdpAnchorMaxObservedHeaderBottomPx = 0;
          applyStickyNavigationReleaseStyles();
        } else {
          stickyLayerElement.removeAttribute('data-pdp-anchor-overlay-active');
          stickyLayerElement.removeAttribute('data-pdp-anchor-overlay-concealed');
          stickyLayerElement.removeAttribute('aria-hidden');
        }
      }

      window.requestAnimationFrame(function () {
        var activeNavigationLink = navigationRootElement.querySelector('.pdp-anchor-navigation__link--active');
        if (activeNavigationLink) {
          positionUnderlineIndicator(activeNavigationLink);
        }
        scheduleDesktopNavigationTrackFit();
      });
    }

    function positionUnderlineIndicator(activeNavigationLink) {
      if (!activeNavigationLink) return;
      var indicatorHeight = underlineIndicatorElement.offsetHeight || 2;
      underlineIndicatorElement.style.left = activeNavigationLink.offsetLeft + 'px';
      underlineIndicatorElement.style.width = activeNavigationLink.offsetWidth + 'px';
      underlineIndicatorElement.style.top =
        activeNavigationLink.offsetTop + activeNavigationLink.offsetHeight - indicatorHeight + 'px';
    }

    function setActiveNavigationLink(activeNavigationLink) {
      if (!activeNavigationLink) return;
      navigationLinkElements.forEach(function (singleNavigationLink) {
        var isCurrent = singleNavigationLink === activeNavigationLink;
        singleNavigationLink.classList.toggle('pdp-anchor-navigation__link--active', isCurrent);
        if (isCurrent) {
          singleNavigationLink.setAttribute('aria-current', 'location');
        } else {
          singleNavigationLink.removeAttribute('aria-current');
        }
      });
      positionUnderlineIndicator(activeNavigationLink);
    }

    function findNavigationLinkByScrollKey(scrollKey) {
      if (!scrollKey) return null;
      for (var linkIndex = 0; linkIndex < navigationLinkElements.length; linkIndex++) {
        if (getNavigationLinkScrollKey(navigationLinkElements[linkIndex]) === scrollKey) {
          return navigationLinkElements[linkIndex];
        }
      }
      return null;
    }

    var desktopNavigationFitPendingAnimationFrame = null;

    function scheduleDesktopNavigationTrackFit() {
      if (desktopNavigationFitPendingAnimationFrame !== null) {
        cancelAnimationFrame(desktopNavigationFitPendingAnimationFrame);
      }
      desktopNavigationFitPendingAnimationFrame = window.requestAnimationFrame(function () {
        desktopNavigationFitPendingAnimationFrame = null;
        applyDesktopNavigationTrackNoWrapFit();
      });
    }

    function applyDesktopNavigationTrackNoWrapFit() {
      if (isMobilePdpAnchorNavigationViewport()) {
        navigationTrackElement.style.fontSize = '';
        navigationTrackElement.style.gap = '';
        window.requestAnimationFrame(function () {
          var activeNavigationLinkEl = navigationRootElement.querySelector('.pdp-anchor-navigation__link--active');
          if (activeNavigationLinkEl) positionUnderlineIndicator(activeNavigationLinkEl);
        });
        return;
      }

      navigationTrackElement.style.fontSize = '';
      navigationTrackElement.style.gap = '';
      void navigationTrackElement.offsetWidth;

      var minimumNavigationFontPx = 10;
      var maximumFitIterations = 64;
      var fitIteration = 0;
      while (navigationTrackElement.scrollWidth > navigationTrackElement.clientWidth + 1 && fitIteration < maximumFitIterations) {
        var currentFontPx = parseFloat(window.getComputedStyle(navigationTrackElement).fontSize);
        if (!currentFontPx || currentFontPx <= minimumNavigationFontPx + 0.01) break;
        var widthRatio = navigationTrackElement.clientWidth / navigationTrackElement.scrollWidth;
        var nextFontPx = Math.max(minimumNavigationFontPx, currentFontPx * widthRatio * 0.995);
        if (nextFontPx >= currentFontPx - 0.015) break;
        navigationTrackElement.style.fontSize = nextFontPx + 'px';
        fitIteration++;
      }

      if (navigationTrackElement.scrollWidth > navigationTrackElement.clientWidth + 1) {
        var computedGap = window.getComputedStyle(navigationTrackElement).gap;
        var gapTokens = computedGap.trim().split(/\s+/).filter(Boolean);
        var rowGapPx = parseFloat(gapTokens[0]) || 0;
        var columnGapPx = parseFloat(gapTokens[gapTokens.length - 1]) || rowGapPx;
        var gapShrinkSafety = 0;
        while (
          navigationTrackElement.scrollWidth > navigationTrackElement.clientWidth + 1 &&
          gapShrinkSafety < 48 &&
          columnGapPx > 4
        ) {
          columnGapPx = Math.max(4, columnGapPx * 0.9);
          navigationTrackElement.style.gap = rowGapPx + 'px ' + columnGapPx + 'px';
          gapShrinkSafety++;
        }
      }

      window.requestAnimationFrame(function () {
        var activeNavigationLinkEl = navigationRootElement.querySelector('.pdp-anchor-navigation__link--active');
        if (activeNavigationLinkEl) positionUnderlineIndicator(activeNavigationLinkEl);
      });
    }

    navigationRootElement.__pdpAnchorNavigationSyncDesktopTrackFit = scheduleDesktopNavigationTrackFit;

    if (typeof ResizeObserver !== 'undefined') {
      var desktopNavigationTrackResizeObserver = new ResizeObserver(function () {
        scheduleDesktopNavigationTrackFit();
      });
      desktopNavigationTrackResizeObserver.observe(navigationTrackElement);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncHeaderMetricsToAnchorRoot();
        updateStickyNavigationDock();
        scheduleDesktopNavigationTrackFit();
      });
    }

    function applyScrollSpyNavigationHighlight(matchedNavigationLink) {
      if (!matchedNavigationLink) return;

      var newScrollKey = getNavigationLinkScrollKey(matchedNavigationLink);
      var scrollSpyActiveKeyChanged =
        scrollSpyPreviousActiveScrollKey !== null && scrollSpyPreviousActiveScrollKey !== newScrollKey;
      scrollSpyPreviousActiveScrollKey = newScrollKey;

      setActiveNavigationLink(matchedNavigationLink);

      if (
        scrollSpyActiveKeyChanged &&
        isMobilePdpAnchorNavigationViewport() &&
        navigationTrackHasHorizontalOverflow(navigationTrackElement)
      ) {
        window.requestAnimationFrame(function () {
          centerNavigationLinkInHorizontalTrack(matchedNavigationLink, navigationTrackElement);
        });
      }
    }

    function updateActiveNavigationFromScrollPosition() {
      var documentMaxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      if (window.scrollY >= documentMaxScroll - 3) {
        applyScrollSpyNavigationHighlight(navigationLinkElements[navigationLinkElements.length - 1]);
        return;
      }

      var scrollMarkerPosition =
        window.scrollY + Math.min(window.innerHeight * 0.18, 200);
      var activeScrollKey = getNavigationLinkScrollKey(navigationLinkElements[0]);

      for (var navIndex = 0; navIndex < navigationLinkElements.length; navIndex++) {
        var singleNavigationLink = navigationLinkElements[navIndex];
        var scrollTargetElement = resolveNavigationLinkScrollTarget(singleNavigationLink);
        if (!scrollTargetElement) continue;
        var sectionTopOffset =
          scrollTargetElement.getBoundingClientRect().top + window.scrollY;
        if (sectionTopOffset <= scrollMarkerPosition + 1) {
          activeScrollKey = getNavigationLinkScrollKey(singleNavigationLink);
        }
      }

      var matchedNavigationLink = findNavigationLinkByScrollKey(activeScrollKey);
      applyScrollSpyNavigationHighlight(matchedNavigationLink);
    }

    navigationRootElement.__pdpAnchorNavigationRefreshNaturalTop = refreshNavigationNaturalTopDocument;
    navigationRootElement.__pdpAnchorNavigationUpdateStickyDock = updateStickyNavigationDock;
    navigationRootElement.__pdpAnchorNavigationUpdateSpy = updateActiveNavigationFromScrollPosition;

    function runInitialAnchorBootForRoot() {
      refreshNavigationNaturalTopDocument();
      updateStickyNavigationDock();
      updateActiveNavigationFromScrollPosition();

      var urlHashFragment = (window.location.hash || '').replace(/^#/, '');
      if (urlHashFragment) {
        var navigationLinkFromHash = findNavigationLinkByScrollKey(urlHashFragment);
        if (navigationLinkFromHash) {
          setActiveNavigationLink(navigationLinkFromHash);
        }
      }

      scheduleDesktopNavigationTrackFit();
    }

    navigationLinkElements.forEach(function (singleNavigationLink) {
      singleNavigationLink.addEventListener('click', function (clickEvent) {
        var scrollTargetElement = resolveNavigationLinkScrollTarget(singleNavigationLink);
        if (!scrollTargetElement) return;

        var scrollKey = getNavigationLinkScrollKey(singleNavigationLink);
        if (!scrollKey) return;

        clickEvent.preventDefault();
        setActiveNavigationLink(singleNavigationLink);
        var offsetPx = getScrollClickOffsetBelowFixedChromePx();
        var rect = scrollTargetElement.getBoundingClientRect();
        var targetTop = rect.top + window.scrollY - offsetPx - 8;
        window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
        if (history.replaceState) {
          history.replaceState(null, '', '#' + scrollKey);
        }

        if (navigationTrackHasHorizontalOverflow(navigationTrackElement)) {
          window.requestAnimationFrame(function () {
            centerNavigationLinkInHorizontalTrack(singleNavigationLink, navigationTrackElement);
          });
        }

        var settleScrollHandler = function () {
          refreshNavigationNaturalTopDocument();
          updateStickyNavigationDock();
          updateActiveNavigationFromScrollPosition();
          scheduleDesktopNavigationTrackFit();
          window.removeEventListener('scroll', settleScrollHandler);
        };
        window.addEventListener('scroll', settleScrollHandler, { passive: true });
        window.setTimeout(settleScrollHandler, 600);
      });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        window.requestAnimationFrame(runInitialAnchorBootForRoot);
      });
    } else {
      window.requestAnimationFrame(runInitialAnchorBootForRoot);
    }
  }

  function initAllPdpAnchorNavigationRootsInDocument() {
    document.querySelectorAll('[data-pdp-anchor-navigation-root]').forEach(function (navigationRootCandidate) {
      initPdpAnchorNavigation(navigationRootCandidate);
    });
  }

  var globalScrollFrameQueued = false;

  function dispatchNavigationScrollEffects() {
    document.querySelectorAll('[data-pdp-anchor-navigation-root][data-pdp-anchor-navigation-initialized="true"]').forEach(
      function (navigationRootCandidate) {
        if (typeof navigationRootCandidate.__pdpAnchorNavigationUpdateStickyDock === 'function') {
          navigationRootCandidate.__pdpAnchorNavigationUpdateStickyDock();
        }
        if (typeof navigationRootCandidate.__pdpAnchorNavigationUpdateSpy === 'function') {
          navigationRootCandidate.__pdpAnchorNavigationUpdateSpy();
        }
      }
    );
  }

  function scheduleGlobalNavigationEffects() {
    if (globalScrollFrameQueued) return;
    globalScrollFrameQueued = true;
    window.requestAnimationFrame(function () {
      globalScrollFrameQueued = false;
      dispatchNavigationScrollEffects();
    });
  }

  function dispatchNavigationResizeEffects() {
    document.querySelectorAll('[data-pdp-anchor-navigation-root][data-pdp-anchor-navigation-initialized="true"]').forEach(
      function (navigationRootCandidate) {
        navigationRootCandidate.__pdpAnchorMaxObservedHeaderBottomPx = 0;
        if (typeof navigationRootCandidate.__pdpAnchorNavigationRefreshNaturalTop === 'function') {
          navigationRootCandidate.__pdpAnchorNavigationRefreshNaturalTop();
        }
        if (typeof navigationRootCandidate.__pdpAnchorNavigationUpdateStickyDock === 'function') {
          navigationRootCandidate.__pdpAnchorNavigationUpdateStickyDock();
        }
        if (typeof navigationRootCandidate.__pdpAnchorNavigationUpdateSpy === 'function') {
          navigationRootCandidate.__pdpAnchorNavigationUpdateSpy();
        }
        if (typeof navigationRootCandidate.__pdpAnchorNavigationSyncDesktopTrackFit === 'function') {
          navigationRootCandidate.__pdpAnchorNavigationSyncDesktopTrackFit();
        }
      }
    );
  }

  window.addEventListener('scroll', scheduleGlobalNavigationEffects, { passive: true });
  window.addEventListener('resize', dispatchNavigationResizeEffects);

  var pdpAnchorScrollSettleTimer = null;
  window.addEventListener(
    'scroll',
    function () {
      if (pdpAnchorScrollSettleTimer !== null) {
        clearTimeout(pdpAnchorScrollSettleTimer);
      }
      pdpAnchorScrollSettleTimer = setTimeout(function () {
        pdpAnchorScrollSettleTimer = null;
        document
          .querySelectorAll('[data-pdp-anchor-navigation-root][data-pdp-anchor-navigation-initialized="true"]')
          .forEach(function (root) {
            if (typeof root.__pdpAnchorNavigationUpdateStickyDock === 'function') {
              root.__pdpAnchorNavigationUpdateStickyDock();
            }
          });
      }, 140);
    },
    { passive: true }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPdpAnchorNavigationRootsInDocument);
  } else {
    initAllPdpAnchorNavigationRootsInDocument();
  }

  document.addEventListener('shopify:section:load', initAllPdpAnchorNavigationRootsInDocument);
})();
